<template>
	<div class="page_content explore_entity_inside program insights" aria-label="program guide alumni insights">

    	<div class="row page-heading">
      		<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 input module_heading">
        		<span class="module_icon icon-list"></span>
        		<template v-if="formattedProgramGuide && formattedProgramGuide.title">
              <program-guide-title :program-guide="formattedProgramGuide"></program-guide-title>
            </template>
      		</div>

      		<template v-if="isWidget">
            <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-5 btn_container" :id="'creditProgressPopup_' + programGuide.uuid">
              <b-btn style="width: 225px; padding: 0;" @click="calculateCreditProgressClicked(programGuide)">
                <b-progress :max="progress.total" height="30px" style="cursor: pointer;" show-value>
                  <b-progress-bar :value="Number(selected)" style="background-color: #532a6e;"></b-progress-bar>
                  <b-progress-bar :value="progress.completed" style="background-color: #508002;"></b-progress-bar>
                  <b-progress-bar :value="progress.notPlanned - selected" style="background-color: #cf7908;"></b-progress-bar>
                </b-progress>
              </b-btn>
            </div>
          </template>
          <template v-else>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 btn_container" v-if="showBackToResultButton">
          		<b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
                <span class="btn_ic ic-back"></span>
                <span class="btn_txt"> {{ deCamelCase() }} </span>
              </b-btn>
              <span v-if="showAddCompletedCoursesOnResult">
                <b-button @click="addCompletedCourses" aria-label="add completed courses">Add Completed Courses</b-button>
              </span>
              <span class="lnk_req_credit"
                v-if="showCalculateRequiredCredit && isStudentLogin && planningStream" :id="'creditProgressPopup_' + programGuide.uuid"
                @click="calculateCreditProgressClicked(programGuide)">
                <template v-if="isShowCourseProgressEnabled">
                  <template v-if="showTransferredCoursesCreditProgress">
                    <div style="border: 1px solid #157099; margin: -3px -15px; font-size: 18px;">
                      <span style="font-size: 15px; padding: 0 10px 0 10px; color: #8cbc3f;">saved {{progress.transferredCourses}} out of {{progress.totalCourses}} courses</span>
                    </div>
                  </template>
                  <template v-else>
                    <b-btn style="width: 225px; padding: 0;">
                      <b-progress :max="progress.totalCourses" height="27px" style="cursor: pointer; margin-top: -4px;" show-value>
                        <b-progress-bar :value="progress.transferredCourses" :precision="setPrecision(progress.transferredCourses)" style="background-color: #57b6e6;"></b-progress-bar>
                        <b-progress-bar :value="progress.completedCourses" :precision="setPrecision(progress.completedCourses)" style="background-color: #508002;"></b-progress-bar>
                        <b-progress-bar :value="progress.inProgressCourses" :precision="setPrecision(progress.inProgressCourses)" style="background-color: #9ec758;"></b-progress-bar>
                        <b-progress-bar :value="progress.notStartedCourses" :precision="setPrecision(progress.notStartedCourses)" style="background-color: #f5b318;"></b-progress-bar>
                        <b-progress-bar :value="progress.notPlannedCourses" :precision="setPrecision(progress.notPlannedCourses)" style="background-color: #cf7908;"></b-progress-bar>
                      </b-progress>
                    </b-btn>
                  </template>
                </template>
                <template v-else>
                  <template v-if="showTransferredCoursesCreditProgress">
                    <div style="border: 1px solid #157099; margin: -3px -15px; font-size: 18px;">
                      <span style="font-size: 15px; padding: 0 10px 0 10px; color: #8cbc3f;">saved {{progress.transfered}} out of {{progress.total}} credits</span>
                    </div>
                  </template>
                  <template v-else>
                    <b-btn style="width: 225px; padding: 0;">
                      <b-progress :max="progress.total" height="27px" style="cursor: pointer; margin-top: -4px;" show-value>
                        <b-progress-bar :value="progress.transfered" :precision="setPrecision(progress.transfered)" style="background-color: #57b6e6;"></b-progress-bar>
                        <b-progress-bar :value="progress.completed" :precision="setPrecision(progress.completed)" style="background-color: #508002;"></b-progress-bar>
                        <b-progress-bar :value="progress.inProgress" :precision="setPrecision(progress.inProgress)" style="background-color: #9ec758;"></b-progress-bar>
                        <b-progress-bar :value="progress.notStarted" :precision="setPrecision(progress.notStarted)" style="background-color: #f5b318;"></b-progress-bar>
                        <b-progress-bar :value="progress.notPlanned" :precision="setPrecision(progress.notPlanned)" style="background-color: #cf7908;"></b-progress-bar>
                      </b-progress>
                    </b-btn>
                  </template>
                </template>
              </span>
        		</div>
          </template>
    	</div>


    	<div class="page_content_container">

			<div v-if="formattedProgramGuide && formattedProgramGuide.title">
      			<program-guide-menu
	          		:cipCode="formattedProgramGuide.cipCode"
	          		:programGuideCode="formattedProgramGuide.code"
	          		:type="formattedProgramGuide.type"
	          		:returnTo="returnTo"
	          		:active="'alumniInsights'"
                :isWidget="isWidget"
                :selected="selected">
      			</program-guide-menu>
     		</div>

    		<div class="row pg_content">

    			<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">

					<div class="row pg_sec" style="padding-bottom: 0px; margin-bottom: 0px; width: 100%; margin-left: 2%;">

						<!--
	        			<div class="col-12 hd ace_sec_hd" aria-label="Alumni Insights">
		          			<h2>Alumni Insights</h2>
		          			<span class="hd_bdr"></span>
		          		</div>
		          		-->

	         			<div class="col-12 explore-section">
							<div class="row">
		          				<div class="col-12">

			           				<explore-insight-list :type="'insights'" :isAlumniInsights="'true'"></explore-insight-list>

			        			</div>
		        			</div>
			  			</div>

		          	</div>

	          	</div>

        	</div> <!-- .pg_content -->
          <template v-if="showCreditProgressPopup">
            <explore-program-credit-progress
                :title="selectedProgramGuide.title"
                :stream-id="planningStream.uuid"
                :program-id="selectedProgramGuide.uuid"
                :credit-progress-target-id="creditProgressTargetId"
                :is-widget="isWidget"
                :selected="Number(selected)">
            </explore-program-credit-progress>
          </template>

		</div> <!-- .page_content_container -->



    	<div class="loading-spinner">
      		<b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        		<div class="text-center" style="color: #FFF">
          			<i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
        		</div>
      		</b-modal>
    	</div>


	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import ProgramGuideMenu from './ProgramGuideMenu'
import ProgramGuideTitle from './ProgramGuideTitle'
import ExploreInsightList from '../../explore/components/ExploreInsightList'
import ExploreProgramCreditProgress from '../../explore/components/ExploreProgramCreditProgress'

export default {
  name: 'program-guide-alumni-insights',
  props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'showBackToResultButton', 'isWidget', 'selected', 'loadDataFromServer'],
  components: {
    ProgramGuideMenu,
    ProgramGuideTitle,
    ExploreInsightList,
    ExploreProgramCreditProgress
  },
  data: () => {
    return {
      DEFAULT_TYPE: 'MAJOR',
      DEFAULT_RETURN_TO: 'exploreProgramGuideResults',
      EXPLORE_RESULTS: 'exploreProgramGuideResults',
      selectedProgramGuide: null,
      creditProgressTargetId: '',
      showCreditProgressPopup: false,
      progress: {}
    }
  },

  async mounted () {
    this.loadDataForProgramGuideAlumniInsights()
  },

  methods: {
    ...mapActions([
      'loadProgramGuide',
      'loadProgramGuideCareers',
      'setCurrentFacet',
      'loadLogDashboardActivity',
      'loadProgramCreditProgress'
    ]),
    addCompletedCourses () {
      return this.$router.push({name: 'selfReportedCourseList'})
    },
    setPrecision (n) {
      if (Number(n) === n && n % 1 !== 0) {
        return 1
      }
      return 0
    },
    async loadDataForProgramGuideAlumniInsights () {
      let cipCode = this.cipCode
      let programGuideCode = this.programGuideCode
      let returnTo = this.returnTo && this.returnTo.length ? this.returnTo : this.DEFAULT_RETURN_TO
      if (!cipCode || !programGuideCode) {
        return this.$router.push({ name: returnTo })
      }
      let programGuide = await this.loadProgramGuide({
        cipCode: cipCode,
        programGuideCode: programGuideCode,
        type: this.programGuideType,
        loadDataFromServer: true
      })
      if (!programGuide || !programGuide.cipCode) {
        return this.$router.push({ name: returnTo })
      }
      // load credit progress
      this.progress = await this.loadProgramCreditProgress({streamId: this.planningStream.uuid, programId: programGuide.uuid, recalculate: false})
      // load related career information, if any exists
      await this.loadProgramGuideCareers({ cipCode: programGuide.cipCode, code: programGuide.code, showAllOccupations: true })
      this.loadLogDashboardActivity({action: 'viewProgramAlumniInsights', page: 'viewProgramAlumniInsights', link: '', programCipCode: cipCode})
      this.setCurrentFacet('insights')
    },
    returnToClicked () {
      return this.$router.push({ name: this.returnTo })
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      if (this.returnTo === this.EXPLORE_RESULTS) {
        return 'return to all results'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return result
    },
    calculateCreditProgressClicked (programGuide) {
      this.selectedProgramGuide = programGuide
      this.creditProgressTargetId = 'creditProgressPopup_' + programGuide.uuid
      this.showCreditProgressPopup = true
    },
    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    }
  },
  computed: {
    ...mapState({
      'programGuide': state => state.programguide.programGuideObject,
      'packages': state => state.institution.packages,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'careersObject': state => state.programguide.careers,
      'careerResult': state => state.programguide.careerResult,
      'planningStream': state => state.dashboard.planningStream
    }),
    formattedProgramGuide () {
      let formattedProgramGuide = this.programGuide
      return formattedProgramGuide
    },
    formattedCareer () {
      let formattedCareer = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
      if (!formattedCareer || !formattedCareer.uuid) {
        return {}
      }
      return formattedCareer
    },
    programGuideType () {
      let programGuideType = this.type
      if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
        programGuideType = this.DEFAULT_TYPE
      }
      return programGuideType
    },
    exploreProgramsFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    showAddCompletedCoursesOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultAddCompletedCourses) {
        return false
      }
      return exploreProgramsFlagMap.searchResultAddCompletedCourses.enabled
    },
    showTransferredCoursesCreditProgress () {
      let transferCoursesFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.TRANSFER_PREVIOUS_COURSES_FEATURE_ID]
      if (transferCoursesFeature && transferCoursesFeature.enabled) {
        let flags = transferCoursesFeature.flags
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === 'showTransferredCoursesCreditProgress') {
            return flag.enabled
          }
        }
      }
      return false
    },
    showCalculateRequiredCredit () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultCalculateRequiredCredit) {
        return false
      }
      return exploreProgramsFlagMap.searchResultCalculateRequiredCredit.enabled
    },
    isShowCourseProgressEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCourseProgress' || flags[i].title === 'showCourseProgressOnOverall') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isShowCreditProgressEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCreditProgress') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isStudentLogin () {
      return (localStorage.getItem('userrole') === 'Student')
    }
  },
  watch: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideAlumniInsights.vue